import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { authService } from "../services/AuthServices";

const Profile = () => {
  const encodedData = localStorage.getItem("user");
  const userData = JSON.parse(decodeURIComponent(encodedData));

  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [address_line_1, setAddressLine1] = useState("");
  const [address_line_2, setAddressLine2] = useState("");
  const [addressState, setAddressState] = useState("");
  const [country, setCountry] = useState("");

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    identificationDocument: null,
    identificationNumber: "",
    proofOfAddressDocument: null,
    selfieUpload: null,
    occupation: "",
    sourceOfFunds: "",
  });

  const fetchUser = async () => {
    try {
      const id = localStorage.getItem("id");

      if (!id) {
        return;
      }

      const response = await authService.userInfo(id);

      setFullName(response.data.fullName);
      setEmail(response.data.email);
      setDateOfBirth(response.data.dateOfBirth);
      setPhoneNumber(response.data.phoneNumber);
      setAddressLine1(response.data.address_line_1);
      setAddressLine2(response.data.address_line_2);
      setAddressState(response.data.addressState);
      setCountry(response.data.country);
    } catch (error) {
      console.error("Failed to fetch user:", error);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const id = localStorage.getItem("id");
    try {
      const data = {
        fullName: fullName,
        phoneNumber: phoneNumber,
        email: email,
        dateOfBirth: dateOfBirth,
        address_line_1: address_line_1,
        address_line_2: address_line_2,
        addressState: addressState,
        country: country,
      };

      await authService.userEdit(id, data);
      window.location.reload();
    } catch (error) {
      console.error("Failed to save details:", error);
    }
  };

  const handleChange = (e) => {
    const { id, value, files } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [id]: files ? files[0] : value,
    }));
  };


  const kycSubmit = async (e) => {
    e.preventDefault();

    const id = localStorage.getItem("id");
    let user = localStorage.getItem("user");

    const data = new FormData();
    data.append("identificationDocument", formData.identificationDocument);
    data.append("identificationNumber", formData.identificationNumber);
    data.append("proofOfAddressDocument", formData.proofOfAddressDocument);
    data.append("selfieUpload", formData.selfieUpload);
    data.append("occupation", formData.occupation);
    data.append("sourceOfFunds", formData.sourceOfFunds);
    data.append("kyc_status", "in_progress");

    try {
      const response = await authService.userEdit(id, data);

      if (user) {
        let user = localStorage.getItem("user");
        const decodedUser = decodeURIComponent(user);
        const parsedUser = JSON.parse(decodedUser);
        parsedUser.kyc_status = "in_progress";
        localStorage.setItem("user", JSON.stringify(parsedUser));
      }

      toast.success(
        "KYC details are uploaded successfully. Please wait for the confirmation."
      );
      // setTimeout(() => {
      //   window.location.reload();
      // }, 3000);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Custom styles for yellow buttons
  const buttonStyle = {
    backgroundColor: '#FFD700',
    borderColor: '#FFD700',
    color: '#333',
    fontWeight: '600',
    borderRadius: '8px',
    padding: '10px 20px',
    transition: 'all 0.3s ease',
    border: '1px solid #FFD700'
  };

  const buttonHoverStyle = {
    backgroundColor: '#FFC107',
    borderColor: '#FFC107',
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 8px rgba(255, 215, 0, 0.3)'
  };

  return (
    <>
      <style jsx>{`
        .btn-yellow {
          background-color: #FFD700 !important;
          border-color: #FFD700 !important;
          color: #333 !important;
          font-weight: 600;
          border-radius: 8px;
          padding: 10px 20px;
          transition: all 0.3s ease;
          border: 1px solid #FFD700;
        }
        
        .btn-yellow:hover {
          background-color: #FFC107 !important;
          border-color: #FFC107 !important;
          color: #333 !important;
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(255, 215, 0, 0.3);
        }
        
        .btn-yellow:focus, .btn-yellow:active {
          background-color: #FFB000 !important;
          border-color: #FFB000 !important;
          color: #333 !important;
          box-shadow: 0 0 0 0.2rem rgba(255, 215, 0, 0.25);
        }
        
        .card {
          border-radius: 12px;
          border: 1px solid #e3e6f0;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
          transition: box-shadow 0.3s ease;
        }
        
        .card:hover {
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
        }
        
        .form-control {
          border-radius: 8px;
          border: 1px solid #d1d3e2;
          padding: 12px 15px;
          transition: border-color 0.3s ease;
        }
        
        .form-control:focus {
          border-color: #FFD700;
          box-shadow: 0 0 0 0.2rem rgba(255, 215, 0, 0.25);
        }
        
        .form-label {
          font-weight: 600;
          color: #5a5c69;
          margin-bottom: 8px;
        }
        
        .verification-item {
          padding: 10px 15px;
          border-radius: 8px;
          margin: 5px 0;
          background-color: #f8f9fc;
          border-left: 4px solid transparent;
        }
        
        .verification-item.verified {
          border-left-color: #1cc88a;
          background-color: #f0f9f5;
        }
        
        .verification-item.unverified {
          border-left-color: #e74a3b;
          background-color: #fdf2f2;
        }
        
        .profile-info .row > div {
          padding: 8px 0;
        }
        
        .modal-content {
          border-radius: 12px;
          border: none;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
        }
        
        .modal-header {
          border-bottom: 1px solid #e3e6f0;
          padding: 20px 24px;
        }
        
        .modal-body {
          padding: 24px;
        }
        
        .modal-footer {
          border-top: 1px solid #e3e6f0;
          padding: 20px 24px;
        }
      `}</style>
      
      <div className="body d-flex py-3" style={{ backgroundColor: '#ffffff', minHeight: '100vh' }}>
        <div className="container-xxl">
          <div className="row align-items-center">
            <div className="border-0 mb-4">
              <div className="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap">
                <h3 className="fw-bold mb-0" style={{ color: '#5a5c69' }}>Profile</h3>
              </div>
            </div>
          </div>
          
          {/* Verification Status Section */}
          <div className="row mb-3">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header py-3 d-flex justify-content-between bg-transparent align-items-center">
                  <h6 className="mb-0 fw-bold" style={{ color: '#5a5c69' }}>Verification Status</h6>
                </div>
                <div className="card-body">
                  <div className="row g-3">
                    <div className="col-xl-4">
                      <div className="verification-item verified">
                        <i className="icofont-check-circled text-success fs-5 me-2"></i>
                        Personal Information
                      </div>
                    </div>
                    <div className="col-xl-4">
                      <div className={`verification-item ${userData.identificationDocument_verified ? 'verified' : 'unverified'}`}>
                        {userData.identificationDocument_verified ? (
                          <i className="icofont-check-circled text-success fs-5 me-2"></i>
                        ) : (
                          <i className="icofont-close-circled text-danger fs-5 me-2"></i>
                        )}
                        Government-issued ID
                      </div>
                    </div>
                    <div className="col-xl-4">
                      <div className={`verification-item ${userData.selfieUpload_verified ? 'verified' : 'unverified'}`}>
                        {userData.selfieUpload_verified ? (
                          <i className="icofont-check-circled text-success fs-5 me-2"></i>
                        ) : (
                          <i className="icofont-close-circled text-danger fs-5 me-2"></i>
                        )}
                        Facial Recognition
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row g-3">
            {/* Profile Card */}
            <div className="col-xl-4 col-lg-5 col-md-12">
              <div className="card profile-card flex-column mb-3">
                <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                  <h6 className="mb-0 fw-bold" style={{ color: '#5a5c69' }}>Profile</h6>
                </div>
                <div className="card-body d-flex profile-fulldeatil flex-column">
                  <div className="profile-user text-center w220 mx-auto position-relative">
                    <button
                      className="btn btn-yellow btn-sm"
                      style={{
                        position: "absolute",
                        top: "0",
                        right: "0",
                        borderRadius: '50%',
                        width: '40px',
                        height: '40px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                      data-bs-toggle="modal"
                      data-bs-target="#editprofile"
                    >
                      <i className="icofont-edit"></i>
                    </button>
                  </div>
                  <div className="profile-info w-100">
                    <h6 className="mb-3 mt-2 fw-bold d-block fs-5 text-center" style={{ color: '#5a5c69' }}>
                      {fullName}
                    </h6>
                    <div className="row g-2 pt-2">
                      <div className="col-xl-12">
                        <div className="d-flex align-items-center">
                          <i className="icofont-ui-touch-phone" style={{ color: '#FFD700', fontSize: '18px' }}></i>
                          <span className="ms-3" style={{ color: '#6c757d' }}>{phoneNumber}</span>
                        </div>
                      </div>
                      <div className="col-xl-12">
                        <div className="d-flex align-items-center">
                          <i className="icofont-email" style={{ color: '#FFD700', fontSize: '18px' }}></i>
                          <span className="ms-3" style={{ color: '#6c757d' }}>{email}</span>
                        </div>
                      </div>
                      <div className="col-xl-12">
                        <div className="d-flex align-items-center">
                          <i className="icofont-globe-alt" style={{ color: '#FFD700', fontSize: '18px' }}></i>
                          <span className="ms-3" style={{ color: '#6c757d' }}>
                            {addressState}, {country}
                          </span>
                        </div>
                      </div>
                      <div className="col-xl-12">
                        <div className="d-flex align-items-center">
                          <i className="icofont-address-book" style={{ color: '#FFD700', fontSize: '18px' }}></i>
                          <span className="ms-3" style={{ color: '#6c757d' }}>
                            {address_line_1}, {address_line_2}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* KYC Settings Card */}
            <div className="col-xl-8 col-lg-7 col-md-12">
              <div className="card mb-3">
                <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                  <h6 className="mb-0 fw-bold" style={{ color: '#5a5c69' }}>KYC Settings</h6>
                </div>
                <div className="card-body">
                  <form className="row g-4" onSubmit={kycSubmit}>
                    <div className="col-md-6">
                      <label htmlFor="identificationDocument" className="form-label">
                        Identification Document
                      </label>
                      <input
                        className="form-control"
                        type="file"
                        id="identificationDocument"
                        onChange={handleChange}
                        accept=".pdf,.jpg,.jpeg,.png"
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="identificationNumber" className="form-label">
                        Identification Number
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="identificationNumber"
                        value={formData.identificationNumber}
                        onChange={handleChange}
                        placeholder="Enter ID number"
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="proofOfAddressDocument" className="form-label">
                        Proof Of Address
                      </label>
                      <input
                        className="form-control"
                        type="file"
                        id="proofOfAddressDocument"
                        onChange={handleChange}
                        accept=".pdf,.jpg,.jpeg,.png"
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="selfieUpload" className="form-label">
                        Selfie Upload
                      </label>
                      <input
                        className="form-control"
                        type="file"
                        id="selfieUpload"
                        onChange={handleChange}
                        accept=".jpg,.jpeg,.png"
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="occupation" className="form-label">
                        Occupation
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="occupation"
                        value={formData.occupation}
                        onChange={handleChange}
                        placeholder="Enter your occupation"
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="sourceOfFunds" className="form-label">
                        Source Of Funds
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="sourceOfFunds"
                        value={formData.sourceOfFunds}
                        onChange={handleChange}
                        placeholder="Enter source of funds"
                      />
                    </div>
                    <div className="col-12 mt-4">
                      <button
                        type="submit"
                        className="btn btn-yellow text-uppercase px-5"
                        style={{ fontSize: '14px', letterSpacing: '1px' }}
                      >
                        SUBMIT KYC
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Edit Profile Modal */}
      <div className="modal fade" id="editprofile" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fw-bold" id="expeditLabel1111" style={{ color: '#5a5c69' }}>
                Edit Profile
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="deadline-form">
                <form>
                  <div className="row g-3 mb-3">
                    <div className="col-sm-6">
                      <label htmlFor="item100" className="form-label">
                        Full Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="item100"
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-sm-6">
                      <label htmlFor="dateOfBirth" className="form-label">
                        Date Of Birth
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="dateOfBirth"
                        value={dateOfBirth}
                        onChange={(e) => setDateOfBirth(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="row g-3 mb-3">
                    <div className="col-sm-6">
                      <label htmlFor="mailid" className="form-label">
                        Email
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="mailid"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <div className="col-sm-6">
                      <label htmlFor="phoneid" className="form-label">
                        Phone
                      </label>
                      <input
                        type="tel"
                        className="form-control"
                        id="phoneid"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="row g-3 mb-3">
                    <div className="col-sm-12">
                      <label className="form-label">Address Line 1</label>
                      <input
                        type="text"
                        className="form-control"
                        value={address_line_1}
                        onChange={(e) => setAddressLine1(e.target.value)}
                        placeholder="Street address, apartment, suite, etc."
                      />
                    </div>
                  </div>
                  <div className="row g-3 mb-3">
                    <div className="col-sm-12">
                      <label className="form-label">Address Line 2</label>
                      <input
                        type="text"
                        className="form-control"
                        value={address_line_2}
                        onChange={(e) => setAddressLine2(e.target.value)}
                        placeholder="Additional address information (optional)"
                      />
                    </div>
                  </div>
                  <div className="row g-3 mb-3">
                    <div className="col-sm-6">
                      <label className="form-label">Country</label>
                      <input
                        type="text"
                        className="form-control"
                        value={country}
                        onChange={(e) => setCountry(e.target.value)}
                        placeholder="Enter country"
                      />
                    </div>
                    <div className="col-sm-6">
                      <label htmlFor="state" className="form-label">
                        State
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="state"
                        value={addressState}
                        onChange={(e) => setAddressState(e.target.value)}
                        placeholder="Enter state"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                style={{ borderRadius: '8px' }}
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                type="button"
                className="btn btn-yellow"
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;